import type { Editor, Extensions } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";
import { RowTextAlign, TextColors } from "../../../form/RichTextEditor/RichTextEditor";
import { AttributeToken } from "./attributeToken";

/**
 * The extensions a template's content needs to render: formatting, colours,
 * row alignment and the `attributeToken` chip. Shared by the editor (which adds
 * placeholder, `@` insert and single-line on top) and the read-only view, so
 * both read a stored template the same way.
 */
export const attributeTemplateExtensions = (): Extensions => [
  StarterKit.configure({
    heading: { levels: [1, 2, 3, 4] },
    link: { openOnClick: false },
  }),
  TextColors,
  RowTextAlign.configure({ types: ["heading", "paragraph"] }),
  AttributeToken,
];

/** How many chips in the editor were auto-migrated from a deprecated `@parent/...` key. */
export const countMigratedTokens = (editor: Editor): number => {
  let count = 0;
  editor.state.doc.descendants((node) => {
    if (node.type.name === AttributeToken.name && node.attrs.migratedFrom) count += 1;
  });
  return count;
};
